export const ROLES = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: 'ADMIN',
    MANAGER: 'MANAGER',
    TEAM_LEADER: 'TEAM_LEADER',
    USER: 'USER',
};
export const ALL_ROLE_CODES = Object.values(ROLES);
//# sourceMappingURL=roles.js.map